import * as dom from './wpstg-dom-utils.js';

/**
 * Handle toggle of contact us modal
 */

export default class WpstgContactUs {
  constructor(modalType = 'contact-us', wpstgObject = wpstg) {
    this.wpstgObject = wpstgObject;
    this.characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    this.currentDate = new Date();
    this.modalType = modalType;
    this.init();
  }

  init() {
    this.contactUsModal = '#wpstg-' + this.modalType + '-modal';
    this.askInTheForumForm = this.contactUsModal + ' #wpstg-' + this.modalType + '-report-issue-form';
    this.contactUsSuccessPopup = this.contactUsModal + ' #wpstg-' + this.modalType + '-success-form';
    this.contactUsLoader = this.contactUsModal + ' #wpstg-' + this.modalType + '-report-issue-loader';
    this.contactUsSupport = this.contactUsModal + ' #wpstg-' + this.modalType + '-support-forum';
    this.contactUsButton = document.querySelector('#wpstg-' + this.modalType + '-button');
    this.contactUsButtonBackupTab = document.querySelector('#wpstg--tab--backup  #wpstg-' + this.modalType + '-button');
    this.reportIssueButton = document.querySelector('#wpstg-contact-us-report-issue');
    this.successForm = document.querySelector(this.contactUsModal + ' #wpstg-' + this.modalType + '-success-form');
    this.contactUsReportIssueBtn = document.querySelector(this.contactUsModal + ' #wpstg-' + this.modalType + '-report-issue-btn');
    this.contactUsCloseButton = document.querySelector(this.contactUsModal + ' #wpstg-modal-close');
    this.contactUsSuccessPopupClose = document.querySelector(this.contactUsModal + ' #wpstg-' + this.modalType + '-success-modal-close');
    this.debugCodeCopyButton = document.querySelector(this.contactUsModal + ' #wpstg-' + this.modalType + '-debug-code-copy');
    this.contactUsResponse = document.querySelector(this.contactUsModal + ' #wpstg-' + this.modalType + '-debug-response');
    this.contactUsDebugCodeField = document.querySelector(this.contactUsModal + ' #wpstg-' + this.modalType + '-debug-code');
    this.isDebugWindowOpened = false;
    this.addEvents();
    this.notyf = new Notyf({
      duration: 6000,
      position: {
        x: 'center',
        y: 'bottom',
      },
      dismissible: true,
      types: [
        {
          type: 'warning',
          background: 'orange',
          icon: true,
        },
      ],
    });
  }

  addEvents() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        dom.hide(this.contactUsModal);
        dom.hide(this.askInTheForumForm);
        dom.hide(this.contactUsSuccessPopup);
        dom.hide(this.contactUsSupport);
        this.isDebugWindowOpened = false;
      }
    });
    if (this.contactUsButton !== null) {
      this.contactUsButton.addEventListener('click', () => {
        dom.show(this.contactUsModal);
      });
    }
    if (this.contactUsButtonBackupTab !== null) {
      this.contactUsButtonBackupTab.addEventListener('click', () => {
        dom.show(this.contactUsModal);
      });
    }
    if (this.reportIssueButton !== null) {
      this.reportIssueButton.addEventListener('click', () => {
        if (this.isDebugWindowOpened) {
          dom.hide(this.askInTheForumForm);
        } else {
          dom.show(this.askInTheForumForm);
        }

        this.isDebugWindowOpened = !this.isDebugWindowOpened;
      });
    }

    if (this.contactUsReportIssueBtn !== null) {
      this.contactUsReportIssueBtn.addEventListener('click', () => {
        this.sendDebugInfo();
      });
    }

    if (this.contactUsSuccessPopupClose !== null) {
      this.contactUsSuccessPopupClose.addEventListener('click', () => {
        dom.hide(this.contactUsSuccessPopup);
      });
    }
    if (this.contactUsCloseButton !== null) {
      this.contactUsCloseButton.addEventListener('click', () => {
        dom.hide(this.contactUsModal);
        dom.hide(this.contactUsSupport);
        dom.hide(this.askInTheForumForm);
        this.isDebugWindowOpened = false;
      });
    }
    if (this.debugCodeCopyButton !== null) {
      this.debugCodeCopyButton.addEventListener('click', () => {
        this.copyDebugCode();
        this.notyf.success('Debug code copied to clipboard');
      });
    }
  }

  copyDebugCode() {
    this.contactUsDebugCodeField.select();
    this.contactUsDebugCodeField.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(this.contactUsDebugCodeField.value);
  }

  generateDebugCode(length) {
    let result = '';
    for ( let i = 0; i < length; i++ ) {
      result += this.characters.charAt(Math.floor(Math.random() * this.characters.length));
    }

    return 'wpstg-' + result + '-' + this.currentDate.getHours() + this.currentDate.getMinutes() + this.currentDate.getSeconds();
  }

  sendDebugInfo() {
    dom.show(this.contactUsLoader);
    this.contactUsReportIssueBtn.disabled = true;
    const debugCode = this.generateDebugCode(8);
    fetch(this.wpstgObject.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: new URLSearchParams({
        action: 'wpstg_send_debug_log_report',
        accessToken: this.wpstgObject.accessToken,
        nonce: this.wpstgObject.nonce,
        debugCode: debugCode,
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      this.contactUsReportIssueBtn.disabled = false;
      if (response.ok) {
        return response.json();
      }
    }).then((data) => {
      if (data.response && data.response.sent === true) {
        this.contactUsDebugCodeField.value = debugCode;
        dom.show(this.contactUsSuccessPopup);
        window.debugCode = debugCode;
      } else {
        this.contactUsDebugCodeField.value = (window.debugCode === undefined) ? debugCode: window.debugCode;
        dom.show(this.contactUsSuccessPopup);
      }

      dom.hide(this.contactUsLoader);
    }).catch((error) => {
      dom.hide(this.contactUsLoader);
      dom.show(this.contactUsSupport);
      console.warn(this.wpstgObject.i18n['somethingWentWrong'], error);
    });
  }
}
